import { errorPrefix as loadScriptPrefix } from 'core/utils/load-script';


/**
 * Сентри может применять шаблоны из ignoreErrors к разным полям ошибки
 * в зависимости от имеющихся в ней данных.
 * Сначала методом _getPossibleEventMessages из ошибки выбираются данные,
 * которые будут сопоставляться с шаблоном. Потом утилитой isMatchingPattern
 * проверяется совпадение с переданным шаблоном.
 *
 * REF:
 *  - _getPossibleEventMessages: https://github.com/getsentry/sentry-javascript/blob/5.20.1/packages/core/src/integrations/inboundfilters.ts#L166
 *  - isMatchingPattern: https://github.com/getsentry/sentry-javascript/blob/master/packages/utils/src/string.ts#L91
 */

export default [
  /**
   * Ошибки, связанные с загрузкой и проблемами инициализации воркеров.
   * ВАЖНО: ошибку `script evaluation failed` не игнорим, т.к.
   *        причиной может быть код нашего воркера.
   */
  /ServiceWorker.+(error during installation|fetch)/i,
  /InvalidStateError.+ServiceWorker/i,
  /ServiceWorker.+Failed to access storage/i,
  /ServiceWorker.+Timed out/i,
  'ServiceWorkerRegistration: No URL is associated with the caller\'s document',
  'Failed to get a ServiceWorkerRegistration',
  'The user denied permission to use Service Worker',

  /** Ошибки, возникающие при прерывании загрузки. */
  'TypeError: Failed to fetch',
  'NetworkError when attempting to fetch resource',
  'Error: Network Error', // Ошибка, появляющаяся во время резкого отключения интернета во время загрузки. Даже не имеет кода
  'TypeError: Cancelled',
  'TypeError отменено',

  /** Ошибки, возникающие при сбросе соединения сервером. */
  'Error read ECONNRESET',

  /** Ошибка из whatwg-fetch, который используется swagger-client'ом. */
  'Invalid character in header field name',

  /** 404 или непонятная ошибка. */
  /Error:? (No error|Not Found)/,

  /** Ошибка со сторонних ресурсов. */
  'UnhandledRejection Non-Error promise rejection captured with keys',

  loadScriptPrefix,
  'Network request failed',
  'Gateway Time-out',
  'ResizeObserver loop limit exceeded', // REF: https://stackoverflow.com/a/50387233
  'SecurityError: The operation is insecure', // Похоже, эти ошибки вызваны всякими трекинг-блокировками

];
